import { type MouseEvent, useCallback, useMemo } from 'react';

import { EllipsisVertical } from '@air/next-icons';
import { DropdownMenu, type DropdownMenuOption, renderDropdownItems } from '@air/primitive-dropdown-menu';
import { IconButton } from '@air/primitive-icon-button';

type DropdownMenuWrapperProps = {
  options: DropdownMenuOption[];
  onOpenChange: (open: boolean) => void;
  onEscapeKeyDown?: (event: KeyboardEvent) => void;
  dataTestId: string;
};

export const DropdownMenuWrapper = ({
  options,
  onOpenChange,
  onEscapeKeyDown,
  dataTestId,
}: DropdownMenuWrapperProps) => {
  const handleWrapperMouseEvent = useCallback((e: MouseEvent) => {
    e.stopPropagation();
    e.preventDefault();
  }, []);

  const handleTriggerMouseEvent = useCallback((e: MouseEvent) => {
    e.stopPropagation();
  }, []);

  const trigger = useMemo(
    () => (
      <IconButton
        appearance="ghost"
        color="grey"
        data-testid={dataTestId}
        icon={EllipsisVertical}
        onClick={handleTriggerMouseEvent}
        onMouseDown={handleTriggerMouseEvent}
        onDoubleClick={handleTriggerMouseEvent}
        label="More options"
        size="medium"
      />
    ),
    [dataTestId, handleTriggerMouseEvent],
  );

  return (
    <DropdownMenu
      onOpenChange={onOpenChange}
      onEscapeKeyDown={onEscapeKeyDown}
      trigger={trigger}
      onClick={handleWrapperMouseEvent}
      onMouseDown={handleWrapperMouseEvent}
    >
      {renderDropdownItems({ options })}
    </DropdownMenu>
  );
};
